import src from "IMAGE";
export default { src, width: 207, height: 125, blurWidth: 0, blurHeight: 0};
